const isAllowed = (store, ...roles) => {
	if (store.getters.isRootOrOwner()) {
		return true;
	}

	for (var i = 0; i < roles.length; i++) {
		if (roles[i] == 'All') {
			return true;
		}
		if (store.getters.can(roles[i])) {
			return true;
		}
	}
	return false;
};

export default {
	isAllowed,
};
